import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getAllTicketsLoading: false,
  getAllTicketsFailed: false,
  getAllTicketsReject: false,
  getAllTicketsMessage: [],
  AllTickets: [],

  getTicketDetailsLoading: false,
  getTicketDetailsFailed: false,
  getTicketDetailsReject: false,
  getTicketDetailsMessage: [],
  TicketDetails: [],

  replyToMyTicketLoading: false,
  replyToMyTicketFailed: false,
  replyToMyTicketReject: false,
  replyToMyTicketMessage: [],

  sendNewTicketLoading: false,
  sendNewTicketFailed: false,
  sendNewTicketReject: false,
  sendNewTicketMessage: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_TICKETS_LOADING: {
      return {
        ...state,
        getAllTicketsLoading: true,
        getAllTicketsFailed: false,
        getAllTicketsReject: false,
        getAllTicketsMessage: [],
        AllTickets: [],
      };
    }
    case actionTypes.GET_ALL_TICKETS_SUCCESS: {
      return {
        ...state,
        getAllTicketsLoading: false,
        getAllTicketsFailed: false,
        getAllTicketsReject: false,
        getAllTicketsMessage: [],
        AllTickets: action.payload,
      };
    }
    case actionTypes.GET_ALL_TICKETS_FAILED: {
      return {
        ...state,
        getAllTicketsLoading: false,
        getAllTicketsFailed: true,
        getAllTicketsReject: false,
        getAllTicketsMessage: [],
        AllTickets: [],
      };
    }
    case actionTypes.GET_ALL_TICKETS_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getAllTicketsLoading: false,
        getAllTicketsFailed: false,
        getAllTicketsReject: true,
        getAllTicketsMessage: message,
        AllTickets: [],
      };
    }

    case actionTypes.GET_TICKET_DETAILS_LOADING: {
      return {
        ...state,
        getTicketDetailsLoading: true,
        getTicketDetailsFailed: false,
        getTicketDetailsReject: false,
        getTicketDetailsMessage: [],
        TicketDetails: [],
      };
    }
    case actionTypes.GET_TICKET_DETAILS_SUCCESS: {
      return {
        ...state,
        getTicketDetailsLoading: false,
        getTicketDetailsFailed: false,
        getTicketDetailsReject: false,
        getTicketDetailsMessage: [],
        TicketDetails: action.payload,
      };
    }
    case actionTypes.GET_TICKET_DETAILS_FAILED: {
      return {
        ...state,
        getTicketDetailsLoading: false,
        getTicketDetailsFailed: true,
        getTicketDetailsReject: false,
        getTicketDetailsMessage: [],
        TicketDetails: [],
      };
    }
    case actionTypes.GET_TICKET_DETAILS_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getTicketDetailsLoading: false,
        getTicketDetailsFailed: false,
        getTicketDetailsReject: true,
        getTicketDetailsMessage: message,
        TicketDetails: [],
      };
    }

    case actionTypes.REPLY_TO_MY_TICKET_LOADING: {
      return {
        ...state,
        replyToMyTicketLoading: true,
        replyToMyTicketFailed: false,
        replyToMyTicketReject: false,
        replyToMyTicketMessage: [],
      };
    }
    case actionTypes.REPLY_TO_MY_TICKET_SUCCESS: {
      return {
        ...state,
        replyToMyTicketLoading: false,
        replyToMyTicketFailed: false,
        replyToMyTicketReject: false,
        replyToMyTicketMessage: [],
      };
    }
    case actionTypes.REPLY_TO_MY_TICKET_FAILED: {
      return {
        ...state,
        replyToMyTicketLoading: false,
        replyToMyTicketFailed: true,
        replyToMyTicketReject: false,
        replyToMyTicketMessage: [],
      };
    }
    case actionTypes.REPLY_TO_MY_TICKET_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        replyToMyTicketLoading: false,
        replyToMyTicketFailed: false,
        replyToMyTicketReject: true,
        replyToMyTicketMessage: message,
      };
    }

    case actionTypes.SEND_NEW_TICKET_LOADING: {
      return {
        ...state,
        sendNewTicketLoading: true,
        sendNewTicketFailed: false,
        sendNewTicketReject: false,
        sendNewTicketMessage: [],
      };
    }
    case actionTypes.SEND_NEW_TICKET_SUCCESS: {
      return {
        ...state,
        sendNewTicketLoading: false,
        sendNewTicketFailed: false,
        sendNewTicketReject: false,
        sendNewTicketMessage: [],
      };
    }
    case actionTypes.SEND_NEW_TICKET_FAILED: {
      return {
        ...state,
        sendNewTicketLoading: false,
        sendNewTicketFailed: true,
        sendNewTicketReject: false,
        sendNewTicketMessage: [],
      };
    }
    case actionTypes.SEND_NEW_TICKET_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        sendNewTicketLoading: false,
        sendNewTicketFailed: false,
        sendNewTicketReject: true,
        sendNewTicketMessage: message,
      };
    }

    default:
      return state;
  }
};
